import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  cartService,
  type GoodsOption,
  type GetCartMetaResponse,
} from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { queryKey } from 'shared/src/constant';
import { isNil } from 'shared/src/utils';

export const useAddToCart = (selected: GoodsOption[]) => {
  const goodsSno = useGoodsSno();
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ isForce = false }: { isForce?: boolean } = {}) => {
      return cartService.postAddToCart({
        goods_sno: goodsSno,
        goods_options: selected.map(option => ({
          is_force: isForce,
          delivery_type: option.delivery_type,
          count: option.purchase_count ?? 1,
          text_option: option.message ?? null,
          sno: option.sno,
        })),
      });
    },
    throwOnError: false,
    onSuccess: data => {
      client.setQueryData<{ data: GetCartMetaResponse }>(
        queryKey.cartMeta,
        oldData => {
          if (isNil(oldData)) return oldData;
          return {
            ...oldData,
            carts_count: data.carts_count,
          };
        },
      );
    },
  });
};
